module.exports = __webpack_public_path__ + "img/grillagee-half.9e455de.svg";